<div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
    <div class="tw:w-full tw:px-[15px]">
        <h4 class="tw:m-0">{{data.header}}</h4>
    </div>
    <div class="tw:w-full tw:px-[15px]">
        <div class="rating-progress-bars tw:p-0 tw:py-2">
            <div class="progress-1 tw:items-center">
                <div class="progress">
                    <div #progress class="progress-bar primary-background-colour" role="progressbar"
                        [attr.aria-valuenow]="data.value" aria-valuemin="0" aria-valuemax="100">
                        {{data.value}} </div>
                </div>
            </div>
        </div>
    </div>
</div>